<div class="hbox font-noto">
  @if (loading) {
    <loading class="pos-abs vh-center"></loading>
  }
  @if (!loading) {
    <div class="flex-box">
      <div class="flex-heading">
        <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
          <span class="tw-font-body tw-font-bold tw-text-300 tw-text-white" i18n="@@explore">Explore</span>
        </div>
        @if (unBoughtRegimen) {
          <div class="buy-regimen" (click)="buyRegimen()">
            <span i18n="@@yourTreatmentKitIsReady">Your treatment kit is ready</span>
            <div class="btn" i18n="@@buyNow">Buy Now</div>
          </div>
        }
      </div>
      <div class="flex-content bg-app last:tw-mb-20" #scrollContainer="">
        @for (feed of feedsJSON; track $index; let i = $index) {
          @if (feed) {
            <feed [feed]="feed"
              [visible]="feed?.isVisible"
              [index]="i"
              [isLiked]="feed?.isLiked"
              (likeToggle)="updateIsLikedFromFeedComponent($event, i)"
              (onCTAClick)="onCTAClick($event)"
            (onVideoPlay)="onVideoPlay($event)"></feed>
          }
        }
        @if (!loading && !feeds.length) {
          <div class="empty-hint centerA" i18n="@@noFeedsAvailable"> No Feeds Available </div>
        }
        <div id="intersectionSubElement" style="height: 1px"></div>
      </div>
    </div>
  }
</div>
